// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:23
import { ListCardStatus } from '@models/imported/SagaStateLib/ListCardStatus';
import { CacheChangedInterface } from '@services/cache/cache.service';
import * as moment from 'moment';
import { CStampCard_abstract } from './../abstract/SagaSchema/CStampCard_abstract';

export class CStampCard extends CStampCard_abstract {
  private _status: ListCardStatus;

  public changed(change: CacheChangedInterface) {
    this._status = change.fetchList.getRow(ListCardStatus, this.Status);
    return super.changed(change);
  }

  get title(): string {
    if (this.StampType === 7) {
      return this._status.Name;
    }

    if (this.StampType === 19) {
      return this.$t + '_' + this.StampType + '_' + this.Status;
    }

    return this.$t + '_' + this.StampType;
  }

  get icon(): string {
    switch (this.StampType) {
      case 7:
        return 'flag';
      case 8:
        return 'git-merge';
      case 15:
        return 'open';
      case 17:
        return 'arrow-round-up';
      case 19:
        return 'briefcase';
      case 201:
      case 202:
      case 203:
        return 'map';
      case 406:
        return 'calendar';
    }
    return 'document';
  }

  get text() {
    if (this.StampType === 406) {
      return moment(this.EffectiveDateUtc).format('LLL');
    }
    return this.Text;
  }
}
